import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  DropdownHeaderComponent,
  IconButtonComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-dropdown-header',
  templateUrl: './evaluation-dropdown-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, DropdownHeaderComponent, IconButtonComponent, RouterLink, RtTooltip],
})
export class EvaluationDropdownHeaderComponent {
  protected readonly heading = input.required<string>();
  protected readonly canManageInterviewTemplates = input.required<boolean>();
  protected readonly showBackButton = input<boolean>(false);

  public readonly back = output<void>();
}
